export default __webpack_public_path__ + "static/media/contactpage.c827a39c.png";